import "./millennium.dependencies"
import "./browser/millennium.browser";

const browser = document.createElement("millennium-browser");
if (!(window as any).millennium)
    (window as any).millennium = {}
//let the existing (native) implementation override ours    
else if (millennium.browser) {
    for (const hook in millennium.browser)
        if (millennium.browser.hasOwnProperty(hook))
            (browser as any)[hook] = (millennium.browser as any)[hook]
}
(window as any).millennium.browser = browser;

window.addEventListener("load", () => document.body.appendChild(browser));